import ImpactGraph from "./Graph";

interface DetailsContentProps {
  impact_transport: any;
  impact_lifecycle: any;
  impacts_global: any;
}

export default function DetailedAnalysisContent(props: DetailsContentProps) {

  return (
    <div>
      <ImpactGraph
        impact_lifecycle={props.impact_lifecycle}
        impact_transport={props.impact_transport}
        impacts_global={props.impacts_global}
      />
    </div>
  );
}
